// Page header — icon badge + "Connect" title + app-presence pill.
//
// The pill mirrors DaemonContext's daemonStatus, so it reports the real state
// of the local desktop app rather than a generic on/off.
import styles from "../Connect.module.css";
import { RouteIcon } from "./ConnectIcons";

const PILL = {
  checking:            { label: "CHECKING FOR APP",  tone: "neutral" },
  ready:               { label: "APP OPENED",        tone: "on" },
  "not-authenticated": { label: "APP NOT SIGNED IN", tone: "off" },
  "wrong-user":        { label: "DIFFERENT ACCOUNT", tone: "off" },
  offline:             { label: "APP NOT DETECTED",  tone: "off" },
};

const TONE_CLASS = {
  on: "appPillOn",
  off: "appPillOff",
  neutral: "appPillNeutral",
};

export default function ConnectHeader({ daemonStatus }) {
  const { label, tone } = PILL[daemonStatus] ?? PILL.offline;

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <span className={styles.headerIcon}><RouteIcon size={18} /></span>
        <h1 className={styles.headerTitle}>Connect</h1>
      </div>

      <span className={`${styles.appPill} ${styles[TONE_CLASS[tone]]}`}>
        <span className={styles.pillDot} />
        {label}
      </span>
    </header>
  );
}
